import { render, staticRenderFns } from "./FindBusinessForm.vue?vue&type=template&id=20ec9ea1&scoped=true&"
import script from "./FindBusinessForm.vue?vue&type=script&lang=js&"
export * from "./FindBusinessForm.vue?vue&type=script&lang=js&"
import style0 from "./FindBusinessForm.vue?vue&type=style&index=0&id=20ec9ea1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec9ea1",
  null
  
)

export default component.exports